import { render, staticRenderFns } from "./wordCheck.vue?vue&type=template&id=d80f5ade&scoped=true&"
import script from "./wordCheck.vue?vue&type=script&lang=js&"
export * from "./wordCheck.vue?vue&type=script&lang=js&"
import style0 from "./wordCheck.vue?vue&type=style&index=0&id=d80f5ade&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80f5ade",
  null
  
)

export default component.exports